/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Soft UI Dashboard React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Soft UI Dashboard React layouts
import HomePage from "layouts/home";
import DashboardSummary from "layouts/dashboard";
import Groups from "layouts/groups";
import MakeAuction from "layouts/makeauction";
import Viewmembers from "layouts/viewmembers";
import Attendance from "layouts/attendance";
import Resend from "layouts/resend";
import WhatsAppScheduler from "layouts/whatsapp-scheduler";

//import Playerreg from "layouts/playerreg";


import Mi from "layouts/mi";
import Miold from "layouts/mi_old";
import Miupdatepay from "layouts/miupdatepay";
import Miplain from "layouts/mi_old/plain";

import Playersprint from "layouts/mi_old/playersprint";

import Auction from "layouts/auction";
import TeamPlayers from "layouts/teamplayers";

//import PoolManager from "layouts/fixtures/poolmanager";

//import FixtureManager from "layouts/fixtures/fixture_manager";



import Matchschedules from "layouts/matchschedules";
import Liveauction   from "layouts/liveauction";
import Liveauctionclone   from "layouts/liveauction/clone";
import RegistrationRequests from "layouts/registration-requests";
import ComparisonReport from "layouts/comparison-report";
import SeriesSettings from "layouts/series-settings";
import PlayerDetails from "layouts/player-details";
import YouTubeLiveTeams from "layouts/youtubelive/teams";
import YouTubeLiveCurrentBid from "layouts/youtubelive/currentbid";
import PlayerPdf from "layouts/playerpdf";


import Schedules from "layouts/schedules";
import TermsAndConditions from "layouts/termsandconditions";
import PrivacyPolicy from "layouts/privacypolicy";
import PublicRegistration from "layouts/public-registration";
import PublicRegistrationDemo from "layouts/public-registration/demo";
import LiveAuctions from "layouts/live-auctions";

import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ForgotMyPassword from "layouts/authentication/forgot-my-password";
import NotFound from "NotFound";
// Soft UI Dashboard React icons
import Shop from "examples/Icons/Shop";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";
import CreditCard from "examples/Icons/CreditCard";

const routes = [
  {
    type: "",
    name: "Home",
    key: "",
    route: "/",
    icon: <Shop size="12px" />,
    component: <HomePage />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="12px" />,
    component: <DashboardSummary />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Live Auctions",
    key: "live",
    route: "/live",
    icon: <Office size="12px" />,
    component: <LiveAuctions />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "collapse",
    name: "My Groups",
    key: "groups",
    route: "/groups",
    icon: <Office size="12px" />,
    component: <Groups />,
    noCollapse: true,
  },
  {
    type: "",
    name: "WhatsApp Scheduler",
    key: "whatsapp-scheduler",
    route: "/whatsapp-scheduler",
    icon: <Office size="12px" />,
    component: <WhatsAppScheduler />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Set Auction",
    key: "makeauction",
    route: "/makeauction",
    icon: <Office size="12px" />,
    component: <MakeAuction />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Live Auction",
    key: "liveauction",
    route: "/liveauction",
    icon: <Office size="12px" />,
    component: <Liveauction />,
    noCollapse: true,
    hideSidebar: true,
  },
  

  {
    type: "",
    name: "Live Auction",
    key: "liveauction",
    route: "/liveauction/clone",
    icon: <Office size="12px" />,
    component: <Liveauctionclone />,
    noCollapse: false,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Registration Requests",
    key: "registration-requests",
    route: "/registration-requests",
    icon: <Office size="12px" />,
    component: <RegistrationRequests />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Comparison Report",
    key: "comparison-report",
    route: "/comparison-report",
    icon: <Office size="12px" />,
    component: <ComparisonReport />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Series Settings",
    key: "series-settings",
    route: "/series-settings",
    icon: <Office size="12px" />,
    component: <SeriesSettings />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Player Details",
    key: "player-details",
    route: "/player-details",
    icon: <Office size="12px" />,
    component: <PlayerDetails />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "YouTube Live Teams",
    key: "youtubelive-teams",
    route: "/youtubelive/teams",
    icon: <Office size="12px" />,
    component: <YouTubeLiveTeams />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "YouTube Live Current Bid",
    key: "youtubelive-currentbid",
    route: "/youtubelive/currentbid",
    icon: <Office size="12px" />,
    component: <YouTubeLiveCurrentBid />,
    noCollapse: true,
    hideSidebar: true,
  },

  

  
  {
    type: "",
    name: "Match Invitation",
    key: "mi",
    route: "/mi",
    icon: <Office size="12px" />,
    component: <Mi />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Match Invitation",
    key: "miold",
    route: "/miold",
    icon: <Office size="12px" />,
    component: <Miold />,
    noCollapse: true,
  },

  {
    type: "",
    name: "View Group Members",
    key: "view members",
    route: "/viewmembers",
    icon: <Office size="12px" />,
    component: <Viewmembers />,
    noCollapse: true,
  },{
    type: "",
    name: "View Group Members Attendance",
    key: "view attendance",
    route: "/attendance",
    icon: <Office size="12px" />,
    component: <Attendance />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Resend",
    key: "Resend",
    route: "/resend",
    icon: <Office size="12px" />,
    component: <Resend />,
    noCollapse: true,
  },
  

  {
    type: "",
    name: "Match Participants Update Payment",
    key: "match invitation",
    route: "/miupdatepay",
    icon: <Office size="12px" />,
    component: <Miupdatepay />,
    noCollapse: true,
  },
  

  
  {
    type: "",
    name: "View Match Schedules",
    key: "view schedules",
    route: "/matchschedules",
    icon: <Office size="12px" />,
    component: <Matchschedules />,
    noCollapse: true,
  },
  

  {
    type: "collapse",
    name: "Match Schedules",
    key: "schedules",
    route: "/schedules",
    icon: <CreditCard size="12px" />,
    component: <Schedules />,
    noCollapse: true,
  },
  
  { type: "title", title: "Account Pages", key: "account-pages" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="12px" />,
    component: <Profile />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Sign In",
    key: "sign-in",
    route: "/sign-in",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Sign Up",
    key: "sign-up",
    route: "/sign-up",
    icon: <SpaceShip size="12px" />,
    component: <SignUp />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Forgot my password",
    key: "forgot-my-password",
    route: "/forgot-my-password",
    icon: <SpaceShip size="12px" />,
    component: <ForgotMyPassword />,
    noCollapse: true,
    hideSidebar: true,
  },
  

  {
    type: "",
    name: "Terms and Conditions",
    key: "",
    route: "/termsandconditions",
    icon: <Shop size="12px" />,
    component: <TermsAndConditions />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Privacy Policy",
    key: "",
    route: "/privacypolicy",
    icon: <Shop size="12px" />,
    component: <PrivacyPolicy />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Public Registration",
    key: "public-registration",
    route: "/public-registration",
    icon: <Office size="12px" />,
    component: <PublicRegistration />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "Public Registration Demo",
    key: "public-registration-demo",
    route: "/public-registration-demo",
    icon: <Office size="12px" />,
    component: <PublicRegistrationDemo />,
    noCollapse: true,
    hideSidebar: true,
  },{
    type: "",
    name: "Match Participants Invitation",
    key: "match invitation",
    route: "/mi/plain",
    icon: <Office size="12px" />,
    component: <Miplain />,
    noCollapse: true,
  },{
    type: "",
    name: "Team Players",
    key: "teamplayers",
    route: "/teamplayers",
    icon: <Office size="12px" />,
    component: <TeamPlayers />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Print Match Participantion List",
    key: "match invitation print",
    route: "/mi/playersprint",
    icon: <Office size="12px" />,
    component: <Playersprint />,
    noCollapse: true,
  },
   

  ,{
    type: "",
    name: "Auction",
    key: "auction",
    route: "/auction",
    icon: <Office size="12px" />,
    component: <Auction />,
    noCollapse: true,
  },
  {
    type: "",
    name: "Player PDF Viewer",
    key: "playerpdf",
    route: "/playerpdf",
    icon: <Office size="12px" />,
    component: <PlayerPdf />,
    noCollapse: true,
    hideSidebar: true,
  },
  {
    type: "",
    name: "404",
    key: "",
    route: "*",
    icon: <Shop size="12px" />,
    component: <NotFound />,
    noCollapse: true,
  }
  

];

export default routes;
